import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface StreamLoginIconPropsType {
    className?: string;
    onClick?: () => void;
}

export const StreamLoginIcon = observer(
    'StreamLoginIcon',
    ({ className, onClick }: StreamLoginIconPropsType): JSX.Element => {
        return (
            <SvgElement
                className={className}
                fill='none'
                height='48'
                onClick={onClick}
                viewBox='0 0 48 48'
                width='48'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M19 31L33 22L19 13V31ZM16 42V38H8C6.9 38 5.95833 37.6083 5.175 36.825C4.39167 36.0417 4 35.1 4 34V10C4 8.9 4.39167 7.95833 5.175 7.175C5.95833 6.39167 6.9 6 8 6H40C41.1 6 42.0417 6.39167 42.825 7.175C43.6083 7.95833 44 8.9 44 10V34C44 35.1 43.6083 36.0417 42.825 36.825C42.0417 37.6083 41.1 38 40 38H32V42H16Z'
                    fill='currentColor'
                />
            </SvgElement>
        );
    }
);
